// extracted by mini-css-extract-plugin
module.exports = {"logo":"al2_cz","menu":"al2_ia","logoWrapper":"al2_al3","logoContainer":"al2_g9","ldtContainer":"al2_al4","poweredBy":"al2_al5"};